import { useEffect, useState, useCallback } from 'react';
import isNil from 'lodash/isNil';
import { useDispatch, useSelector } from 'react-redux';
import { getPageData } from 'src/slices/pageStorage';
import { requestStatuses } from '@gulfwinds/ui-components';

const usePageStorage = (getStorageData, getDetails) => {
  const dispatch = useDispatch();

  // Storage

  // Initial state if data loader is passed
  const [isLoaded, setIsLoaded] = useState(isNil(getStorageData));

  const pageStorage = useSelector(({ pageStorage }) => pageStorage);
  const { status: storageStatus, error: storageError, ...storage } = pageStorage;

  useEffect(() => {
    if (!getStorageData) {
      return;
    }

    setIsLoaded(false);
    dispatch(getPageData(getStorageData));
  }, [getStorageData]);

  useEffect(() => {
    if (storageStatus === requestStatuses.FAILED || storageStatus === requestStatuses.SUCCESS) {
      setIsLoaded(true);
    }
  }, [storageStatus]);

  // Details
  const [detailsStatus, setDetailsStatus] = useState(requestStatuses.PENDING);
  const [detailsError, setDetailsError] = useState(null);
  const [details, setDetails] = useState(null);

  const loadDetails = useCallback(() => {
    if (!getDetails) {
      return;
    }
    setDetailsStatus(requestStatuses.PENDING);
    setDetailsError(null);
    getDetails()
      .then((data) => {
        setDetails(data);
        setDetailsStatus(requestStatuses.SUCCESS);
      })
      .catch((error) => {
        setDetailsError(error);
        setDetailsStatus(requestStatuses.FAILED);
      });
  }, [getDetails]);

  useEffect(() => {
    loadDetails();
  }, [loadDetails]);

  return {
    isLoading: !isLoaded
      || isNil(storageStatus)
      || storageStatus === requestStatuses.INIT
      || storageStatus === requestStatuses.PENDING
      || (!isNil(getDetails) && detailsStatus === requestStatuses.PENDING),
    isFailed: isLoaded && (storageStatus === requestStatuses.FAILED || detailsStatus === requestStatuses.FAILED),
    error: storageError ?? detailsError,
    details,
    reloadDetails: loadDetails,
    setDetails,
    ...storage,
  };
};

export default usePageStorage;
